import React from 'react';
import {
  Box,
  Text,
  constants
} from '@match/react-component-library';
import {
  SyntheticButton
} from '../../../app-core-components';

import { PageLayout } from '../../layouts';

const { SPACE, TYPOGRAPHY, FONT_WEIGHT, SEMANTIC_COLOR_NAME } = constants

class LandingPage extends React.Component<{}> {
  render() {
    return (
      <PageLayout dark>
        <Box
          paddingBottom={SPACE.XXLARGE}
        >
          <Text
            fontSize={TYPOGRAPHY.H1}
            fontWeight={FONT_WEIGHT.BOLD}
            color={SEMANTIC_COLOR_NAME.LIGHT}
          >
            The gift of love</Text>
        </Box>
        <Box
          paddingBottom={SPACE.XLARGE}
        >
          <Text
            fontSize={TYPOGRAPHY.SMALLBODY}
            color={SEMANTIC_COLOR_NAME.LIGHT}
          >
            Ready to unwrap the perfect match?</Text>
        </Box>
        <Box
          width="200px"
          paddingBottom={SPACE.MEDIUM}
        >
          <a href="https://www.match.com/cpx/en-us/landing/giftcard/indexpage/?trackingid=602176&bannerId=9545599">
            <SyntheticButton
              size="xlarge"
              inverse
              color={SEMANTIC_COLOR_NAME.DARK}
              fullWidth
            >
              Create an account
            </SyntheticButton>
          </a>
        </Box>
        <Box
          width="200px"
        >
          <a href="https://www.match.com/login?to=/gift/redeem">
            <SyntheticButton
              size="xlarge"
              inverse
              fontColor={SEMANTIC_COLOR_NAME.PRIMARY1}
              color={SEMANTIC_COLOR_NAME.LIGHT}
              fullWidth
            >
              Already a member
            </SyntheticButton>
          </a>
        </Box>
      </PageLayout>
    )
  }
}

export default LandingPage;
